import { configureStore, combineReducers } from "@reduxjs/toolkit";
import AsyncStorage from "@react-native-async-storage/async-storage";
import storageSession from "redux-persist/lib/storage/session";
import persistReducer from "redux-persist/lib/persistReducer";
import authReducer from "../Redux/authSlice";
import subscriptionReducer from "../Redux/subscriptionSlice";
import orgReducer from "../Redux/orgDetailsSlice";
import dashboardSlice from "../Redux/dashboardSlice";
import errorReducer from "../Redux/errorSlice";
import loaderReducer from "../Redux/loaderSlice";
// import pre_SignReducer from "../Redux/preSignSlice";
// import mainReportSlice from "../Redux/mainReportSlice";
import fhsDrilldownReducer from "../Redux/fhsDrilldownRedux";
// import opportunitiesReducer from "../Redux/opportunitiesDataSlice";
// import missingproductReducer from "../Redux/missingDataSlice";
// import secondaryconsumerReducer from "../Redux/secondaryConsumer";
// import ghostconsumerReducer from "../Redux/ghostConsumer";
import navigationHistoryReducer from "../Redux/navigationHistorySlice";
import selectedFilterSlice from "../Redux/selectedFilterSlice";
import financialHealthScoreAnalysisSlice from "../rtk-query/features/dashboard/financialHealthScore/financialHealthScoreAnalysisSlice";
import healthAnalysisSlice from "../rtk-query/features/healthAnalysis/healthAnalysisSlice";
import clusterSlice from "../Redux/clusterSlice";
import maintenanceSlice from "../Redux/maintenanceSlice";
import campaignHistorySlice from "../Redux/campaignHistorySlice";
import privilegesSlice from "../Redux/privilegesSlice";
import { opportunitiesAnalysisSlice } from "../rtk-query/features/dashboard/opportunities/opportunitiesAnalysisSlice";
// import { missingProductsAnalysisSlice } from "../rtk-query/features/dashboard/missingProducts/missingProductsAnalysisSlice";
import { ghostConsumerAnalysisSlice } from "../rtk-query/features/dashboard/ghostConsumer/ghostConsumerAnalysisSlice";
import { secondaryConsumerAnalysisSlice } from "../rtk-query/features/dashboard/secondaryConsumer/secondaryConsumerAnalysisSlice";
import { topCompetitorsAnalysisSlice } from "../rtk-query/features/dashboard/topCompetitors/topCompetitorsAnalysisSlice";
import { fileAnalyticsAnalysisSlice } from "../rtk-query/features/dashboard/fileAnalytics/fileAnalyticsAnalysisSlice";
import { missedRevenueAnalysisSlice } from "../rtk-query/features/dashboard/missedRevenue/missedRevenueAnalysisSlice";
import { bondScoreAnalysisSlice } from "../rtk-query/features/dashboard/bondScore/bondScoreAnalysisSlice";
// import { efficiencyRatioAnalysisSlice } from "../rtk-query/features/dashboard/efficiencyRatio/efficiencyRatioAnalysisSlice";
import { topMerchantsAnalysisSlice } from "../rtk-query/features/dashboard/topMerchants/topMerchantsAnalysisSlice";
import { consumerDemographicsAnalysisSlice } from "../rtk-query/features/dashboard/consumerDemographics/consumerDemographicsAnalysisSlice";
import { topPersonaAnalysisSlice } from "../rtk-query/features/dashboard/topPersona/topPersonaAnalysisSlice";
// import { newUserGrowthAnalysisSlice } from "../rtk-query/features/dashboard/newUserGrowth/newUserGrowthAnalysisSlice";
import { rtkQueryErrorLogger } from "../rtk-query/features/rtkQueryErrorLogger";
import { registrationSlice } from "../rtk-query/features/auth/register/registrationSlice";
import allCohortReducer from "../Redux/allCohortSlice";

import { emailTemplatesSlice } from "../rtk-query/features/campaign/email-campaign/emailTemplatesSlice";
import { emailCampaignsSlice } from "../rtk-query/features/campaign/email-campaign/emailCampaignsSlice";
import { consumerListSlice } from "../rtk-query/features/campaign/email-campaign/consumerListSlice";
import { consumerListDetailsSlice } from "../rtk-query/features/campaign/email-campaign/consumerListDetailsSlice";
import { autoPilotLookupsSlice } from "../rtk-query/features/campaign/email-campaign/autopilotLookupsSlice";
import { signUpSlice } from "../rtk-query/features/auth/register/signUpSlice";
import { bankPerformanceMerticsSlice } from "../rtk-query/features/bankPerformanceMetrics/bankPerformanceMerticsSlice";
import { stripeSlice } from "../rtk-query/features/stripe/stripeSlice";
import { userManagementSlice } from "../rtk-query/features/usermanagement/userManagementSlice";
import { infiniteBankPerformanceMetricsSlice } from "../rtk-query/features/infiniteBankPerformanceMetricsSlice/infiniteBankPerformanceMetricsSlice";
import { insightsAndRecommendationSlice } from "../rtk-query/features/insightsAndRecommendation/insightsAndRecommendationSlice";
import { missingRevenueTrendSlice } from "../rtk-query/features/dashboard/trends/missingRevenueTrendSlice";
import { bondScoreTrendSlice } from "../rtk-query/features/dashboard/trends/bondScoreTrendSlice";
import { ghostConsumersTrendSlice } from "../rtk-query/features/dashboard/trends/ghostConsumersTrendSlice";
import { opportunitiesTrendSlice } from "../rtk-query/features/dashboard/trends/opportunitiesTrendSlice";
import { secondaryConsumersTrendSlice } from "../rtk-query/features/dashboard/trends/secondaryConsumersTrendSlice";
import { contactUsSlice } from "../Redux/contactUsSlice";
import chartImageReducer from "../rtk-query/features/chartImage/chartImageSlice";
import { externalDepositSlice } from "../rtk-query/features/dashboard/secondaryConsumer/externalDepositSlice";
import { initialFilterDataSlice } from "../Redux/initialFilterDataSlice";
import paginationSlice from "../Redux/paginationSlice";
import { notificationRTK } from "../rtk-query/features/usernotification/notificationRTK";
import notificationSlice from "../rtk-query/features/usernotification/notificationSlice";
import { cohortRTK } from "../rtk-query/features/cohort/cohortRTK";
import cohortSlice from "../rtk-query/features/cohort/cohortSlice";
import ewiSlice from "../rtk-query/features/downloadFHSReport/downloadFHSReportSlice";
import lockedCampaignSlice from "../rtk-query/features/lockedCampaignSlice";
import { downloadFHSReportRTK } from "../rtk-query/features/downloadFHSReport/downloadFHSReportRTK";

const rootPersistConfig = {
  key: "root",
  storage: storageSession,
  blacklist: ["authReducer"],
};

const rootReducer = combineReducers({
  authReducer: authReducer,
  orgReducer: orgReducer,
  dashboardReducer: dashboardSlice,
  errorReducer: errorReducer,
  subscriptionReducer: subscriptionReducer,
  loaderReducer: loaderReducer,
  stripeReducer: stripeSlice.reducer,
  bankPerformanceMerticsSlice: bankPerformanceMerticsSlice.reducer,
  infiniteBankPerformanceMetricsReducer:
    infiniteBankPerformanceMetricsSlice.reducer,
  signUpReducer: signUpSlice.reducer,
  // pre_SignReducer: pre_SignReducer,
  // hidReducer: mainReportSlice,
  // opportunitiesReducer: opportunitiesReducer,
  // missingproductReducer: missingproductReducer,
  // secondaryconsumerReducer: secondaryconsumerReducer,
  // ghostconsumerReducer: ghostconsumerReducer,
  navigationHistoryReducer: navigationHistoryReducer,
  selectedFilterSlice: selectedFilterSlice,
  fhsDrilldownReducer: fhsDrilldownReducer,
  allCohortReducer: allCohortReducer,
  chartImageReducer: chartImageReducer,
  financialHealthScoreAnalysisReducer: financialHealthScoreAnalysisSlice,
  healthAnalysisReducer: healthAnalysisSlice,
  notificationReducer: notificationSlice,
  lockedCampaignReducer: lockedCampaignSlice,
  clusterReducer: clusterSlice,
  maintenanceReducer: maintenanceSlice,
  campaignHistoryReducer: campaignHistorySlice,
  privilegesReducer: privilegesSlice,
  paginationReducer: paginationSlice,
  cohortReducer: cohortSlice,
  ewiReducer: ewiSlice,
  emailCampaigns: emailCampaignsSlice.reducer,
  emailTemplates: emailTemplatesSlice.reducer,
  consumerList: consumerListSlice.reducer,
  consumerListDetails: consumerListDetailsSlice.reducer,
  autopilotLookupsSlice: autoPilotLookupsSlice.reducer,
  userManagementReducer: userManagementSlice.reducer,
  contactUsReducer: contactUsSlice.reducer,
  externalDepositReducer: externalDepositSlice.reducer,
  [opportunitiesAnalysisSlice.reducerPath]: opportunitiesAnalysisSlice.reducer,
  // [missingProductsAnalysisSlice.reducerPath]:
  //   missingProductsAnalysisSlice.reducer,
  [ghostConsumerAnalysisSlice.reducerPath]: ghostConsumerAnalysisSlice.reducer,
  [secondaryConsumerAnalysisSlice.reducerPath]:
    secondaryConsumerAnalysisSlice.reducer,
  [topCompetitorsAnalysisSlice.reducerPath]:
    topCompetitorsAnalysisSlice.reducer,
  [fileAnalyticsAnalysisSlice.reducerPath]: fileAnalyticsAnalysisSlice.reducer,
  // [secondaryConsumerAnalysisSlice.reducerPath]:
  //   secondaryConsumerAnalysisSlice.reducer,
  [missedRevenueAnalysisSlice.reducerPath]: missedRevenueAnalysisSlice.reducer,
  [bondScoreAnalysisSlice.reducerPath]: bondScoreAnalysisSlice.reducer,
  // [efficiencyRatioAnalysisSlice.reducerPath]:
  //   efficiencyRatioAnalysisSlice.reducer,
  // [secondaryConsumerAnalysisSlice.reducerPath]:
  //   secondaryConsumerAnalysisSlice.reducer,
  // [topCompetitorsAnalysisSlice.reducerPath]:
  //   topCompetitorsAnalysisSlice.reducer,

  // [fileAnalyticsAnalysisSlice.reducerPath]: fileAnalyticsAnalysisSlice.reducer,
  [topMerchantsAnalysisSlice.reducerPath]: topMerchantsAnalysisSlice.reducer,
  [consumerDemographicsAnalysisSlice.reducerPath]:
    consumerDemographicsAnalysisSlice.reducer,
  [topPersonaAnalysisSlice.reducerPath]: topPersonaAnalysisSlice.reducer,
  // [newUserGrowthAnalysisSlice.reducerPath]: newUserGrowthAnalysisSlice.reducer,
  [bondScoreTrendSlice.reducerPath]: bondScoreTrendSlice.reducer,
  [ghostConsumersTrendSlice.reducerPath]: ghostConsumersTrendSlice.reducer,
  [missingRevenueTrendSlice.reducerPath]: missingRevenueTrendSlice.reducer,
  [opportunitiesTrendSlice.reducerPath]: opportunitiesTrendSlice.reducer,
  [secondaryConsumersTrendSlice.reducerPath]:
    secondaryConsumersTrendSlice.reducer,
  [registrationSlice.reducerPath]: registrationSlice.reducer,
  [autoPilotLookupsSlice.reducerPath]: autoPilotLookupsSlice.reducer,
  [insightsAndRecommendationSlice.reducerPath]:
    insightsAndRecommendationSlice.reducer,
  [notificationRTK.reducerPath]: notificationRTK.reducer,
  [cohortRTK.reducerPath]: cohortRTK.reducer,
  [downloadFHSReportRTK.reducerPath]: downloadFHSReportRTK.reducer,
  [initialFilterDataSlice.reducerPath]: initialFilterDataSlice.reducer,
});

export const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableStateInvariant: false,
    }).concat([
      opportunitiesAnalysisSlice.middleware,
      // missingProductsAnalysisSlice.middleware,
      ghostConsumerAnalysisSlice.middleware,
      secondaryConsumerAnalysisSlice.middleware,
      topCompetitorsAnalysisSlice.middleware,
      fileAnalyticsAnalysisSlice.middleware,
      missedRevenueAnalysisSlice.middleware,
      bondScoreAnalysisSlice.middleware,
      // efficiencyRatioAnalysisSlice.middleware,
      topMerchantsAnalysisSlice.middleware,
      consumerDemographicsAnalysisSlice.middleware,
      topPersonaAnalysisSlice.middleware,
      // newUserGrowthAnalysisSlice.middleware,
      bondScoreTrendSlice.middleware,
      ghostConsumersTrendSlice.middleware,
      missingRevenueTrendSlice.middleware,
      opportunitiesTrendSlice.middleware,
      secondaryConsumersTrendSlice.middleware,
      registrationSlice.middleware,
      autoPilotLookupsSlice.middleware,
      insightsAndRecommendationSlice.middleware,
      notificationRTK.middleware,
      cohortRTK.middleware,
      downloadFHSReportRTK.middleware,
      initialFilterDataSlice.middleware,
      rtkQueryErrorLogger,
    ]),
});
export default store;
